import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Login } from '../../redux/Slices/AuthSlice'
import notify from '../UseNotification'
import { useNavigate } from 'react-router-dom'
import UseProtectedLinks from './UseProtectedLinks'

const UseLogin = () => {
    const [isLogin, isUser, isAdmin] = UseProtectedLinks()
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [loading, setLoading] = useState("")
    const [isPress, setIsPress] = useState(false)
    const [isFormValid, setIsFormValid] = useState(false)
    const { LoginData } = useSelector(state => state.AuthReducer)

    // onchange email value
    const onChangeEmail = (e) => {
        setEmail(e.target.value)
    }

    // onchange password value
    const onChangePassword = (e) => {
        setPassword(e.target.value)
    }

    // on blur validate Email
    const validateEmail = (e) => {
        if (e.target.value === "") {
            notify("you must enter the email", "error")
        } else if (!e.target.value.match(emailRegex)) {
            notify("please enter correct email", "error")
        }
    }

    // on blur validate Email
    const validatePassword = (e) => {
        if (e.target.value.length < 6) {
            notify("password must be at least 6 character-", "error")
        }
    }

    // to handle disable submit button
    useEffect(() => {
        if (email && password && password.length >= 6 && email.match(emailRegex)) {
            setIsFormValid(true)
        } else {
            setIsFormValid(false)
        }
    }, [email, password])

    // onSubmit
    const Submit = async () => {
        setIsPress(true)
        setLoading(true)
        await dispatch(Login({
            email,
            password
        }))
        setLoading(false)
    }

    // handle after recieve response
    useEffect(() => {
        if (loading === false) {
            setIsPress(false)
            if (LoginData.data) {
                localStorage.setItem("token", LoginData.data.token)
                notify("Login Success", "success")
                setTimeout(() => {
                    window.location.reload(false)
                }, 1500)
            }
            if (LoginData.response) {
                if (LoginData.response.data.errors) {
                    LoginData.response.data.errors.map((item) => notify(item.msg, "error"))
                    localStorage.removeItem("token");
                } if (LoginData.response.data) {
                    notify(LoginData.response.data.message, "error")
                    localStorage.removeItem("token");
                }
            }
        }
    }, [loading])

    // to handle navigate after login
    useEffect(() => {
        if (isAdmin === true) {
            navigate("/admin/allproducts")
        }
        if (isUser === true) {
            navigate("/")
        }
    }, [isAdmin, isUser])

    return [isPress, validateEmail, validatePassword, loading, email, password, onChangeEmail, onChangePassword, Submit, isFormValid]
}

export default UseLogin
